
import Page from './common/page';

class GoogleTranslate {
    constructor() {
        this.state = {
            defaultCode: "ru",
            langCode: "ru",
        }

        this.containers = document.querySelectorAll('.language__list')
        this.toggleButtons = document.querySelectorAll('.language__toggle')
        this.overlays = document.querySelectorAll('.language__list-overlay')
        this.selectedLanguages = document.querySelectorAll('.language__selected')

        window.addEventListener('load', this.onLoad.bind(this));
        this.forEachNode(this.toggleButtons, (node) => node.addEventListener('click', this.toggleListView.bind(this)))
        this.forEachNode(this.overlays, (node) => node.addEventListener('click', this.toggleListView.bind(this)))
        this.forEachNode(this.selectedLanguages, (node) => node.addEventListener('click', this.toggleListView.bind(this)))

        let translate = localStorage.getItem('translate');

        if (translate && window.location.hash.match('(Topic|Tag)\\w+') === null){
            const translate = "#googtrans(" + this.state.defaultCode + "|"+ JSON.parse(localStorage.getItem('lang-local')) +")";
            window.location = translate
            localStorage.setItem('translate', JSON.stringify(translate));
        } else if (window.location.hash.match('(Topic|Tag)\\w+')){
            return
        } else{
            const trans = "#googtrans(" + this.state.defaultCode + "|"+ this.state.langCode +")";
            window.location = trans;
            localStorage.setItem('translate', JSON.stringify(trans));
        }
    }

    forEachNode(nodes, fn) {
        nodes.forEach(fn)
    }

    toggleListView() {
        const lists = document.querySelectorAll('.language__list-container')
        const buttons = document.querySelectorAll('.language__toggle')

        document.querySelector('body').classList.toggle('not-scrollable')

        this.forEachNode(lists, (list) => {
            list.classList.toggle("language__list-container_opened")
        })

        this.forEachNode(buttons, (button) => {
            button.classList.toggle("language__toggle_opened")
        })
    }

    onLoad() {
        const langLocalJSON = localStorage.getItem('lang-local');
        const langLocal = JSON.parse(langLocalJSON) || this.state.langCode

        this.state.langCode = langLocal;

        document.cookie = "googtrans=/ru/" + this.state.langCode;

        const languageListScriptTag = document.querySelector('script[id="language-list"]')
        const languageList = JSON.parse(languageListScriptTag?.innerText || '{}')

        this.renderLanguages(languageList)
    }

    // render lang-list
    renderLanguages(ggl) {
        const languages = Object.entries(ggl);

        const nodesTuples = languages.map(([langCode, langName]) => {
            const node = document.createElement('li')
            node.classList.add('language__list-elem')
            node.textContent = langName

            if (langCode == this.state.langCode) {
                node.classList.add('language__list-elem_selected')

                const languageNames = document.querySelectorAll('.language__selected')
                this.forEachNode(languageNames, (nameContainer) => nameContainer.textContent = langName)
            }

            return [langCode, node]
        })

        this.forEachNode(this.containers, container => {
            // cloning nodes to be able to append them to several places
            const clonedNodes = nodesTuples.map(([langCode, node]) => {
                const clonedNode = node.cloneNode(true)
                clonedNode.addEventListener('click', this.onChange.bind(this, langCode))

                return clonedNode
            })

            container.append(...clonedNodes)
        })
    }

    onChange(newLanguage) {
        localStorage.setItem('lang-local', JSON.stringify(newLanguage))
        this.state.langCode = newLanguage

        const googleTranslate = "#googtrans(" + this.state.defaultCode + "|"+ newLanguage +")";
        localStorage.setItem("translate", JSON.stringify(googleTranslate))
        window.location = googleTranslate

        location.reload();
    }
}

export class NewGoogleForPages extends Page {
    init() {
        try{
            this.googleTranslate = new GoogleTranslate();
        }catch (e){
            console.log(e)
            document.querySelector('.header-submenu__languages').style.display = "none"
        }

    }
}
